import type { Topic } from "@/types/video";

export const topics: Topic[] = [
  {
    id: "summer-love",
    keyword: "综艺",
    name: "恋综追踪季",
    description:
      "从选角到收官，把本季最受关注的情感观察类综艺逐期拆解，看嘉宾关系如何真实演进。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20romantic%20abstract%20scene%20with%20deep%20red%20and%20amber%20bokeh%20lights%2C%20soft%20dreamy%20cinematic%20glow%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail%2C%20consistent%20palette&width=600&height=600&seq=topic-01&orientation=squarish",
  },
  {
    id: "hot-scenes",
    keyword: "名场面",
    name: "影视名场面",
    description:
      "盘点近年影视剧里被反复二创的高光片段，逐帧解析镜头、表演与配乐的配合秘诀。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20abstract%20composition%20with%20deep%20red%20spotlight%20and%20gold%20particles%2C%20moody%20dramatic%20lighting%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail&width=600&height=600&seq=topic-02&orientation=squarish",
  },
  {
    id: "star-style",
    keyword: "造型",
    name: "明星穿搭志",
    description:
      "从红毯到私服，邀请造型师解读明星穿搭思路，教你读懂廓形、配色与趋势信号。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20fashion%20abstract%20background%20with%20deep%20red%20silk%20texture%20and%20soft%20gold%20glow%2C%20luxurious%20moody%20cinematic%20lighting%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail&width=600&height=600&seq=topic-03&orientation=squarish",
  },
  {
    id: "year-meme",
    keyword: "热搜",
    name: "年度热梗回顾",
    description:
      "一年里刷屏的那些梗从哪来、怎么火、又被谁带偏？一份轻松又有料的年度网络文化观察。",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20abstract%20neon%20collage%20of%20glowing%20shapes%20in%20deep%20red%20and%20orange%20tones%2C%20energetic%20cinematic%20lighting%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail&width=600&height=600&seq=topic-04&orientation=squarish",
  },
];

export default topics;